﻿﻿import { IUser } from './user';

export interface ISession {
    id: number;
    token: string;
    lastLogged: Date;
    sessionStarted: Date;
    lastPageView: string;
    browserAgent: string;
    ipAddress: string;
    userId: number;
    user: IUser;
}
